import { render, staticRenderFns } from "./ground_edit.vue?vue&type=template&id=3b54c7bc&"
import script from "./ground_edit.vue?vue&type=script&lang=ts&"
export * from "./ground_edit.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports